import { render } from "./NavigationDesktop.vue?vue&type=template&id=6b89ea7b"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js"

import "./NavigationDesktop.vue?vue&type=style&index=0&id=6b89ea7b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__